export default function ResultsSummary() {
  return (
    <section className="py-20 sm:py-24 lg:py-32 px-4 sm:px-6 bg-gradient-to-b from-white via-gray-50/30 to-white">
      <div className="max-w-6xl mx-auto">
        {/* セクションタイトル */}
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e3a8a] mb-6 sm:mb-8 leading-tight">
            50代以上の女性層を動かす「3つの事実」
          </h2>
          
          {/* 導入リード文 */}
          <div className="max-w-4xl mx-auto mb-12 sm:mb-16">
            <p className="text-base sm:text-lg lg:text-xl text-gray-700 leading-relaxed px-4">
              長年のメディアキャリアに加え、独自のオンラインサロンや韓国語スクールといった<strong className="text-[#1e3a8a]">「熱量の高い独自のコミュニティ」</strong>を自ら主宰。ターゲット層のインサイトを直接掌握しているからこそ、以下の数字が実現しています。
            </p>
          </div>
        </div>

        {/* 最短完売記録 - 最も目立つ位置 */}
        <div className="mb-16 sm:mb-20 text-center">
          <div className="inline-block bg-gradient-to-r from-[#d4af37] to-[#f4d03f] rounded-2xl px-10 sm:px-16 py-8 sm:py-12 shadow-2xl">
            <div className="flex items-center justify-center gap-3 sm:gap-5 mb-3">
              <i className="ri-trophy-line text-4xl sm:text-5xl text-white"></i>
              <h3 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white">
                最短完売記録
              </h3>
            </div>
            <p className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white">
              募集開始から<span className="text-5xl sm:text-6xl mx-2">1日</span>で定員到達
            </p>
            <p className="text-lg sm:text-xl text-white/90 mt-3 font-semibold">
              （当日完売）
            </p>
          </div>
        </div>

        {/* その他の実績数値 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 sm:gap-14">
          <div className="text-center">
            <div className="flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-5 bg-gradient-to-br from-[#1e3a8a] to-[#3b82f6] rounded-full">
              <i className="ri-group-line text-3xl sm:text-4xl text-white"></i>
            </div>
            <div className="text-5xl sm:text-6xl lg:text-7xl font-bold text-[#1e3a8a] mb-3">
              5万人+
            </div>
            <p className="text-xl sm:text-2xl lg:text-3xl text-gray-700 font-bold">
              SNSリーチ数
            </p>
          </div>

          <div className="text-center">
            <div className="flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-5 bg-gradient-to-br from-[#1e3a8a] to-[#3b82f6] rounded-full">
              <i className="ri-map-pin-line text-3xl sm:text-4xl text-white"></i>
            </div>
            <div className="text-5xl sm:text-6xl lg:text-7xl font-bold text-[#1e3a8a] mb-3">
              30回+
            </div>
            <p className="text-xl sm:text-2xl lg:text-3xl text-gray-700 font-bold">
              ツアー同行実績
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}